// Para crear un solo event listener para todos los componentes al hacer resize
// sacado de https://blog.logrocket.com/developing-responsive-layouts-with-react-hooks/
// https://es.reactjs.org/docs/context.html
// https://hackernoon.com/simplifying-responsive-layouts-with-react-hooks-19db73893a7a

import React, { createContext, useContext, useState, useEffect } from 'react';


const viewportContext = createContext({});

const ViewportProvider = ({ children }) => {
  const [width, setWidth] = React.useState(window.innerWidth);
  const [height, setHeight] = React.useState(window.innerHeight);
  const handleWindowResize = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };

  React.useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  return (
    <viewportContext.Provider value={{ width, height }}>
      {children}
    </viewportContext.Provider>
  );
};

export default ViewportProvider;
export const useViewportDimensions = () => useContext(viewportContext);
